import type { Phrases } from '../../types';
import type { PhrasesWithEmail } from './email-finder';

const stringAsEmailRegex = /[\p{L}\d._%+-]+@[\p{L}\d.-]+\.[\p{L}]{2,}/gu;

export function emailSetter(
  phrases: Phrases,
  phrasesWithEmail: PhrasesWithEmail
) {
  if (!phrasesWithEmail.length) {
    return phrases;
  }

  phrasesWithEmail.forEach(({ phraseIndex, emails }) => {
    const translatedEmails = [
      ...phrases[phraseIndex].matchAll(stringAsEmailRegex)
    ];

    translatedEmails.forEach((email, index) => {
      phrases[phraseIndex] = phrases[phraseIndex].replace(
        email[0],
        emails[index]
      );
    });
  });

  return phrases;
}
